import script from "./AsideForCommunication.vue?vue&type=script&setup=true&lang=js"
export * from "./AsideForCommunication.vue?vue&type=script&setup=true&lang=js"

import "./AsideForCommunication.vue?vue&type=style&index=0&id=56c21187&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56c21187"]])

export default __exports__